import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/responsive.css'
import { installSecureFetch } from './services/auth'
import { ossImageUrl } from './utils/ossImage'
import GenerationFailureDetails from './components/GenerationFailureDetails.vue'
import GenerationModelDetails from './components/GenerationModelDetails.vue'
import AppPagination from './components/AppPagination.vue'
import WorkflowTuningButton from './components/WorkflowTuningButton.vue'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.component('GenerationFailureDetails', GenerationFailureDetails)
Vue.component('GenerationModelDetails', GenerationModelDetails)
Vue.component('AppPagination', AppPagination)
Vue.component('WorkflowTuningButton', WorkflowTuningButton)
Vue.prototype.$ossImageUrl = ossImageUrl
installSecureFetch()

window.addEventListener('auth-expired', () => {
  if (router.currentRoute.name !== 'login') {
    router.replace({ name: 'login', query: { redirect: router.currentRoute.fullPath } }).catch(() => {})
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
